module.exports = __webpack_public_path__ + "assets/arrow_left-190ca0.svg";